module.exports = __webpack_public_path__ + "static/media/strong12.e31af48b.jpg";